//import { createRouter, createWebHashHistory } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import LeaderboardsView from "../views/leaderboards-view.vue";

const routes = [
  {
    path: "/",
    name: "Leaderboards",
    component: LeaderboardsView,
  },
];

const router = createRouter({
  //mode: "history",
  //history: createWebHashHistory(),
  history: createWebHistory(),
  //history: process.env.IS_ELECTRON ? createWebHashHistory(process.env.BASE_URL) : createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
